import { render } from "./inventory.vue?vue&type=template&id=b4953b3e&scoped=true"
import script from "./inventory.vue?vue&type=script&lang=js"
export * from "./inventory.vue?vue&type=script&lang=js"

import "./inventory.vue?vue&type=style&index=0&id=b4953b3e&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4953b3e"]])

export default __exports__